import { Next } from '@shipengine/giger';
import { HELP_CENTER_KEYS, useHelpCenter } from '@packlink/provider';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { useTranslation } from '@packlink/translation-provider';

export const Footer = (): JSX.Element => {
    const { t } = useTranslation();
    const getSupportPage = useHelpCenter();

    const {
        externalPages: { survey: surveyUrl },
    } = useTenantConfig<ITenantConfig>();

    return (
        <footer className="footer">
            {window.location.pathname === '/new_label' && surveyUrl && (
                <p className="footer__text">
                    {t('footer.text.label-printing')}&nbsp;
                    <Next.Link href={surveyUrl} target="_blank" isExternal>
                        {t('footer.link.survey')}
                    </Next.Link>
                    .
                </p>
            )}
            <p className="footer__legal">
                <Next.Link href={getSupportPage(HELP_CENTER_KEYS.termsAndConditions)} target="_blank" isExternal>
                    {t('footer.link.terms-and-conditions')}
                </Next.Link>
                .&nbsp;
                <Next.Link href={getSupportPage(HELP_CENTER_KEYS.privacyPolicy)} target="_blank" isExternal>
                    {t('footer.link.privacy-policy')}
                </Next.Link>
                .{t('footer.text.managed-by')}
            </p>
        </footer>
    );
};
